module.exports = __webpack_public_path__ + "img/1219424878.054c9467.jpg";